module.exports = __webpack_public_path__ + "img/ic-info.cee49010.svg";